import * as React from 'react';
import {withTranslation} from "react-i18next";
import ReactPlayer from "react-player";
import {useState} from "react";
import {Modal} from "reactstrap";
import Constants from "./Constants";

const HelpButton = (props) => {

    const [url, setUrl] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const onHelpClick = () => {
        const pathUrl = 'https://www.youtube.com/watch?v=NDLVe53LKlc';
        setUrl(pathUrl);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    let context;
    if (Constants.HOST_WEBSITE !== 'ddn') {
        context = <span className="commonRoundBtn roundBtn">{props.t('HELP')}</span>
        //context = <span className="commonRoundBtn roundBtn helpSpan"><i className="material-icons helpIcon">help_outline</i></span>
    } else {
        context = <span className="commonRoundBtn roundBtn helpSpan"><i className="material-icons helpIcon">help_outline</i></span>
    }

    return (
        <div>
            <div className="commonControl"
                 onClick={() => onHelpClick()}>
                {context}
            </div>
            <Modal isOpen={modalOpen} toggle={toggleModal} centered={true}>
                <ReactPlayer url={url} controls={true} width='auto'/>
            </Modal>
        </div>
    );
};

export default withTranslation('common')(HelpButton);
